import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'om',
    fullName: 'Oromo',
    nativeName: 'Oromoo',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid jedhamuun beekama",
    landing_title: "Waan Ajaa'ibaatu Dhufaa jira",
    landing_subtitle: "ArgVoid istuudiyoo appii fi tapha qopheessuudha. Nu eegaa, wanti haaraan yeroo dhiyootti dhufaa jira!",
    select_language: "Afaan Filadhu",
    search_placeholder: "Afaanota barbaadi...",
    terms_title: "Haala Tajaajilaa",
    policy_title: "Imaammata Dhuunfaa",
    cookies_title: "Imaammata Kukii",
    terms_content: `
        <strong>1. Fudhatama Jechoota</strong><br>
        ArgVoid argachuudhaan, Haalawwan Tajaajilaa kun fudhatama argatu. Yoo haalawwan kun irratti walii hin galle tajaajilichi itti fayyadamuu hin qabu.<br><br>

        <strong>2. Fayyadama Waltajjii</strong><br>
        ArgVoid fi aplikeeshiniiwwan isaa "akkuma jirutti" kaayyoo odeeffannoo fi kalaqaaf kan kennamanidha. Tajaajilli kun kaayyoo seera qabeessa qofaaf itti fayyadamuu qaba.<br><br>

        <strong>3. Gocha Dhorkaa</strong><br>
        Saaxilamummaa marsariitii fayyadamuun, spam gochuun, ykn bu’uuraalee misoomaa hayyama malee argachuuf yaaluun cimsee dhorkaadha.<br><br>

        <strong>4. Hubachiisa</strong><br>
        Waltajjii fi tajaajilli kun yeroo kamiyyuu beeksisa malee fooyya’uu ni danda’a. Yeroo hojii ykn argama tajaajilichaa ilaalchisee wabiin hin kennamu.
    `,
    policy_content: `
        <strong>1. Odeeffannoo Walitti Qabuu</strong><br>
        Waltajjiin kun yeroo kanatti mirkaneessa fayyadamaa ykn herrega uumuu hin barbaadu. Odeeffannoon dhuunfaa adda baasu kamiyyuu (kan akka maqaa ykn teessoo imeelii) daawwattoota irraa dammaqinaan hin sassaabamu.<br><br>

        <strong>2. Deetaa Fayyadamaa</strong><br>
        Xiinxala bu’uuraa, maqaa hin beekamne walitti qabuun tiraafikaa saayitii hubachuu fi aplikeeshiniiwwan fooyyessuu danda’a. Deetaan kun eenyummaa fayyadamaa dhuunfaa wajjin hin walqabsiifamu.<br><br>

        <strong>3. Tajaajila Qaama Sadaffaa</strong><br>
        Tajaajila keessummeessuu fi xiinxalaaf dhiyeessitoonni qaama sadaffaa itti fayyadamuu ni danda’u. Gochi icciitii dhiyeessitoota walfakkaataa kanaa daataa maqaa hin beekamne bu’uuraalee misoomaa isaanii irratti adeemsifamu ni bulcha.<br><br>

        <strong>4. Nageenya Deetaa</strong><br>
        Waltajjicha eeguuf tarkaanfiiwwan nageenyaa madaalawaa ta’an hojiirra oola. Haa ta’u malee, mala interneetii irratti dabarsuu kamiyyuu guutummaatti nageenya hin qabu.<br><br>
    `,
    cookies_content: `
        <strong>1. Kuukiiwwanii fi Kuusaa Naannoo maali?</strong><br>
        Kuukiiwwanii fi kuusaan naannoo biraawzari faayiloota deetaa xixiqqoo meeshaa irratti kuufamanii filannoo qindeessaa daawwannaa hunda keessatti yaadachuuf.<br><br>

        <strong>2. Kaayyoo Itti Fayyadamaa</strong><br>
        Browser LocalStorage qindaa'inoota qindeessaa qusachuuf cimsee fayyadama, kan akka:<br>
        - Filannoo afaanii<br>
        - Qindaa'ina walqunnamtii fayyadamaa (fkn, qindaa'ina haala ykn mata duree)<br>
        - Yeroodhaaf application cache<br><br>

        <strong>3. Hordoffii Hin Qabu</strong><br>
        Kuukiiwwanii fi kuusaan naannoo beeksisaaf ykn hordoffii qaama sadaffaatiif hin fayyadamu. Daataan kuufame hundi cimsee hojii ijoo waltajjii.<br><br>

        <strong>4. To'annoo</strong><br>
        Deetaan biraawzari yeroo kamiyyuu karaa qindaa'inoota biraawzari qulqullaa'uu danda'a, kunis qindeessaa naannoo kamiyyuu deebisee ni saaga.
    `,
    cookie_consent_text: "Kukiiwwan bu'uuraa fayyadamnee marsariitichi sirritti akka hojjetu mirkaneessuuf, kan akka turtii kee sochii taasisuu, filannoo afaan kee qusachuu, fi qindeessaa amala biroo.",
    read_policy: "Imaammata Kukii dubbisi",
    support_title: "Deeggarsa Qunnamtii",
    support_subject_label: "Mata duree",
    support_message_label: "Ergaa",
    support_submit_button: "Ergaa Ergaa",
    support_hint: "Hubachiisa: Kun ergaa erguuf application email durtii keessan bana.",
    support_success_msg: "Appii email keessanii banuun...",
    support_error_msg: "Ergaa erguu hin dandeenye. Mee booda irra deebi'ii yaalaa.",
    explorer_title: "Explorer",
    history_title: "Seenaa",
    animation_title: "Animeeshinii",
    config_title: "Qindeessituu",
    tool_mouse: "(Ctrl+M) filadhu.",
    tool_brush: "Buruushiin (Ctrl+B) .",
    tool_brush_mode: "Haala Jijjiirraa (Jabaa/Qulqulluu) .",
    tool_eraser: "Haquu (Ctrl+E) .",
    tool_brush_size: "Safara Buruushiin Sirreessaa",
    tool_bucket: "Guutuu (Ctrl+F) .",
    tool_eyedropper: "Ija namaa kan dhangalaasu",
    tool_grid: "Giriidii (Ctrl+Shift+B) 1.1.",
    tool_rotate: "Naanneffachuu (Ctrl+Shift+R) .",
    tool_flip_h: "Gargalchuu H (Ctrl+Shift+H) .",
    tool_flip_v: "Gargalcha V (Ctrl+Jijjiirraa+V) .",
    tool_transpose: "Jijjiirraa (Ctrl+Shift+T) .",
    label_width: "Bal'ina",
    label_height: "Hojjaa",
    label_frames: "Lakkoofsa Fureemii",
    label_animation: "Akkaataa Animeeshinii",
    label_background_color: "Halluu Duubbee",
    label_interval: "Giddugaleessa",
    tool_anim_config: "Qindeessituu Animeeshinii",
    label_new_width: "Bal'ina Haaraa",
    label_new_height: "Olka'iinsa Haaraa",
    label_apply: "Hojiirra oolchuu",
    label_colors: "Halluuwwan",
    label_size: "Hamma ga'u",
    label_tolerance: "Obsaan danda'uu",
    val_horizontal: "Dalga-galii",
    val_vertical: "Ol kan dhaabbatu",
    val_sequence: "Tartiiba",
    val_bounce: "Irradeddeebiin lafa rukutee ol ka'uu",
    val_random: "Akka carraa",
    val_solid: "Jabaataa",
    val_clear: "Ifaa",
    action_add_sheet: "Waraqaa Haaraa",
    action_import: "Biyya alaatii galchuu",
    action_export: "Alergii",
    action_sort_projects: "Secca'uu",
    sort_date_old: "Kan Durii Tokkoffaa",
    sort_date_new: "Haaraa Dura",
    sort_name_az: "Maqaa (A-Z) .",
    sort_name_za: "Maqaa (Z-A) .",
    action_new_sprite: "Ispiraayitii Haaraa",
    action_new_project: "Pirojektii Haaraa",
    modal_save_all_title: "Jijjiirama Hunda Qusadhu",
    modal_save_all_desc: "Qabeenya qusachuuf filadhu:",
    modal_save_selected: "Save Filatame",
    action_saved: "Qusatame",
    modal_create_sprite_title: "Sprite Haaraa Uumuu",
    modal_create_project_title: "Pirojektii Haaraa Uumuu",
    modal_add_sheet_title: "Waraqaa Haaraa Dabaluu",
    modal_rename_sheet_title: "Waraqaa Maqaa Jijjiiri",
    modal_rename_sprite_title: "Maqaa Sprite jedhu jijjiiri",
    modal_delete_sprite_title: "Sprite haquu",
    modal_delete_project_title: "Pirojektii Haquu",
    modal_delete_sheet_title: "Waraqaa Haquu",
    placeholder_sprite_name: "Maqaa",
    placeholder_project_name: "Maqaa",
    placeholder_sheet_name: "Maqaa",
    placeholder_new_name: "Maqaa Haaraa",
    action_create: "Uumuu",
    action_add: "Ida'uu",
    action_rename: "Maqaa jijjiiri",
    action_duplicate: "Duplicate gochuu",
    action_delete: "Haquu",
    action_cancel: "Haquu",
    confirm_delete_sprite: "Sprite kana haquu akka barbaaddu mirkaneeffatteettaa?",
    confirm_delete_project: "Pirojektii kana haquu akka barbaaddu mirkaneeffatteettaa? Ispriitonni hundi ni haqamu.",
    confirm_delete_sheet: "Waraqaa kana haquu akka barbaaddu mirkaneeffatteettaa?",
    err_select_sprite: "Maaloo dursa sprite filadhu.",
    err_select_project: "Mee dursa pirojektii tokko filadhu.",
    err_name_empty: "Maqaan duwwaa ta'uu hin danda'u.",
    err_sprite_exists: "Sprite maqaa sana qabu duraan jira.",
    err_project_exists: "Pirojektiin maqaa sana qabu duruu jira.",
    err_no_content: "Qabiyyee qusachuu hin qabu.",
    err_no_changes: "Jijjiirama qusachuuf hin jiru.",
    err_delete_last_sheet: "Waraqaa isa dhumaa haquu hin danda'u.",
    err_extract_frames: "Fureemii tokkollee baasuu hin dandeenye.",
    err_indexeddb: "Naannootti qusachuu hin dandeenye. Browser kee IndexedDB deeggaru dhiisuu danda'a.",
    msg_upload_success: "Olkaa'uun Milkaa'e: {0}",
    msg_upload_failed: "Olkaa'uun Hin milkoofne: {0}",
    msg_save_success: "Qusachuu milkaa'aa.",
    msg_saving: "Qusachuu...",
    msg_multi_save_result: "Qabeenya {0} qusatame. {1} kufaatii.",
    menu_title: "Menu",
    menu_save: "Qusachuu",
    menu_save_all: "Hundaa Qusachuu",
    menu_support: "Deeggarsa Qunnamtii",
    label_local_storage: "Kuusaa Naannoo",
    label_sign_in: "Sign In",
    modal_export_title: "Sprite erguu",
    label_filename: "Maqaa faayilii",
    label_format: "Akkaataa",
    action_export_confirm: "Alergii",
};

export default translations;
